import { faArrowUpRightFromSquare as externalLinkIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import classNames from 'classnames';
import { useAtom } from 'jotai';
import Markdown from 'react-markdown';

import LargeCard from '@/components/LargeCard';
import MarkdownLink from '@/components/MarkdownLink';
import {
  escapeStrikethrough,
  MARKDOWN_REMARK_PLUGINS
} from '@/constants/markdown.constants';
import { ticketAtom } from '@/pages/Ticket';
import { convertLogscaleLinks } from '@/utils/Common.utils';

import useStyles from './TicketDetailsDescription.styles';
import TicketDetailsDescriptionTemplates from './TicketDetailsDescriptionTemplates';

const TicketDetailsDescription = () => {
  const [{ summary, title, investigate_url }] = useAtom(ticketAtom);
  const { classes } = useStyles();

  return (
    <LargeCard
      title="Description"
      rightContent={
        investigate_url && (
          <Link
            href={convertLogscaleLinks(investigate_url)}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <Stack direction="row" sx={{ alignItems: 'center', gap: '0.3rem' }}>
              <FontAwesomeIcon icon={externalLinkIcon} />
              <b>Investigate</b>
            </Stack>
          </Link>
        )
      }
    >
      <Stack spacing={2}>
        <span
          className={classNames(
            'ticketDetailsDescriptionSummary',
            classes.ticketDetailsDescriptionSummary
          )}
        >
          <Markdown
            disallowedElements={['img']}
            remarkPlugins={MARKDOWN_REMARK_PLUGINS}
            unwrapDisallowed
            components={{
              a: MarkdownLink
            }}
          >
            {escapeStrikethrough(summary || title)}
          </Markdown>
        </span>
        <TicketDetailsDescriptionTemplates />
      </Stack>
    </LargeCard>
  );
};

export default TicketDetailsDescription;
